import Repository from "@/repositories/Repository";

export default {
  query(payload) {
    // TODO: send query to backend in order to retrieve filter data?
    let resource = "/filters/";
    return Repository.post(`${resource}`, payload);
  },
};
